import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_5 = { class: "w-full my-6 px-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "font-semibold text-xl text-[#101828]" }
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "cursor-pointer absolute top-4 right-4",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_843_13544)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.05992 6.00016C6.21665 5.55461 6.52602 5.1789 6.93322 4.93958C7.34042 4.70027 7.81918 4.61279 8.2847 4.69264C8.75022 4.77249 9.17246 5.01451 9.47664 5.37585C9.78081 5.73718 9.94729 6.19451 9.94659 6.66683C9.94659 8.00016 7.94659 8.66683 7.94659 8.66683M7.99992 11.3335H8.00659M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z",
      stroke: "#98A2B3",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_843_13544" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "cursor-pointer absolute top-4 right-4",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_843_13544)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.05992 6.00016C6.21665 5.55461 6.52602 5.1789 6.93322 4.93958C7.34042 4.70027 7.81918 4.61279 8.2847 4.69264C8.75022 4.77249 9.17246 5.01451 9.47664 5.37585C9.78081 5.73718 9.94729 6.19451 9.94659 6.66683C9.94659 8.00016 7.94659 8.66683 7.94659 8.66683M7.99992 11.3335H8.00659M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z",
      stroke: "#98A2B3",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_843_13544" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "cursor-pointer absolute top-4 right-4",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_843_13544)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.05992 6.00016C6.21665 5.55461 6.52602 5.1789 6.93322 4.93958C7.34042 4.70027 7.81918 4.61279 8.2847 4.69264C8.75022 4.77249 9.17246 5.01451 9.47664 5.37585C9.78081 5.73718 9.94729 6.19451 9.94659 6.66683C9.94659 8.00016 7.94659 8.66683 7.94659 8.66683M7.99992 11.3335H8.00659M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z",
      stroke: "#98A2B3",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_843_13544" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_12 = { class: "suffix-icons flex items-center justify-center relative top-[-1.3rem] right-[0.7rem] gap-8" }
const _hoisted_13 = { class: "suffix-icons flex items-center justify-center absolute top-[0.90rem] right-[0.7rem] gap-8" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "font-semibold text-md text-[#101828] mt-1" }, "Subjects & Classes", -1)
const _hoisted_16 = { class: "flex justify-between items-center" }
const _hoisted_17 = { class: "w-1/2" }
const _hoisted_18 = { class: "w-1/2" }
const _hoisted_19 = { class: "flex gap-4" }
const _hoisted_20 = { class: "w-1/2" }
const _hoisted_21 = { class: "w-1/2" }
const _hoisted_22 = { class: "flex items-center justify-between gap-2 w-full pt-4" }
const _hoisted_23 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_24 = { class: "font-normal pl-1" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "rounded-md bg-red-50 p-4 w-full mt-6 sm:w-full sm:max-w-4xl"
}
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "flex-shrink-0" }
const _hoisted_29 = { class: "ml-3" }
const _hoisted_30 = { class: "text-sm font-medium text-red-800" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_32 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_33 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_34 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_35 = { class: "flex flex-col items-center px-8 py-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.5 24L22.5 27L28.5 21M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_37 = { class: "mt-6 font-semibold text-2xl text-[#101828]" }
const _hoisted_38 = { class: "font-normal text-sm text-[#101828] text-center mt-2" }
const _hoisted_39 = { class: "font-bold" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "font-bold" }
const _hoisted_42 = { class: "mt-8 flex gap-4 text-base w-full" }

import { computed, ref, watch } from "vue";
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { FormKitNode } from "@formkit/core";
import showPasswordIcon from "@/assets/auth-module/show-password.svg";
import hidePasswordIcon from "@/assets/auth-module/hide-password.svg";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { useFilterStore } from "@/stores/filterStore";
import { XCircleIcon } from "@heroicons/vue/20/solid";

// Interface for a new learner object
interface NewLearner {
  lastName: string;
  firstName: string;
  email: string;
  studentNumber: string | "";
  password: string;
  grade: string | number;
  subjects: {
    maths: boolean;
    english: boolean;
  };
  mathsClass: string;
  englishClass: string;
  schoolId: string;
}

// Props for the component

export default /*#__PURE__*/_defineComponent({
  __name: 'AddLearnerModalComponent',
  props: {
  className: {
    type: String,
    required: true,
  },
  classId: {
    type: String,
    required: true,
  },
},
  emits: ["hideModel"],
  setup(__props, { emit }) {

const props = __props;



// Stores for managing state
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const licenseStore = useLicenseStore();
const filterStore = useFilterStore();

// Reactive variables
const addedLearnerResults = ref(false);
const updateSingleLearner = ref(true);
const passwordVisible = ref(false);
const newLearner = ref<NewLearner>({
  lastName: "",
  firstName: "",
  email: "",
  studentNumber: "",
  password: "",
  grade: filterStore.selectedFilters.gradeLevel || 6,
  schoolId: filterStore.selectedFilters.school || null,
  subjects: {
    maths: false,
    english: false,
  },
  mathsClass: "",
  englishClass: ""

});

// Emit event setup


// Function to toggle password visibility
const togglePasswordVisibility = (value: string) => {
  if (value == "password") {
    passwordVisible.value = !passwordVisible.value;
  }
};

// Generate email for the new learner
const generateEmail = () => {
  const email = `${newLearner.value.firstName.toLowerCase()}.${newLearner.value.lastName.toLowerCase()}@${
    schoolStore.getCurrentSchool?.domain
  }`;
  newLearner.value.email = email;
};

// Generate password for the new learner
const generatePassword = () => {
  const password = newLearner.value.firstName.slice(0, 3) + "123";
  newLearner.value.password = password.toLowerCase();
};

// Get current subject
const getCurrentSubject = computed(() => {
  const subject = filterStore.selectedFilters.subject;
  const subjectName = filterStore.filterOptions?.subjects.find(
    (item: any) => item._id === subject
  );
  return subjectName?.name;
});

let noSeats = ref(false);

// Function to handle the creation of a new learner
const onCreateLearner = async (value: NewLearner) => {
  if (licenseStore.license?.products) {
    for (const product of licenseStore.license.products) {
      if (product.product.name === getCurrentSubject.value) {
        // Check if there are available seats
        const availableSeats = product.maxSeats - product.seatsUsed;
        if (availableSeats > 0) {
          // Assign learnerData & Exclude unwanted properties
          const { maths, english, mathsClass, englishClass, ...learnerData } = value; 
          const learnerDetails = {
            ...learnerData,
            classes: [
              ...(value.mathsClass ? [value.mathsClass] : []),
              ...(value.englishClass ? [value.englishClass] : []),
            ],
            subjects: [
            ...(value.maths ? ["MATHS"] : []),
            ...(value.english ? ["ENGLISH"] : []),
            ]
          };

          // Creating the learner
          const response = await learnerStore.createLearner(learnerDetails);

          // // If the learner is created successfully, show the confirmation modal
          if (response) {
            updateSingleLearner.value = false;
            addedLearnerResults.value = true;
          }
        } else {
          console.log("No available seats.");
          noSeats.value = true;
        }
      }
    }
  } else {
    console.log("No license found.");
    noSeats.value = true;
  }
};

// Computed property to get the password icon
const getPasswordIcon = computed(() => {
  return passwordVisible.value ? showPasswordIcon : hidePasswordIcon;
});

// Function to close the modal
const closeModal = () => {
  updateSingleLearner.value = false;
  emit("hideModel");
};

// Function to handle confirmation of learner addition and reset the form
const handleConfirmLearner = () => {
  emit("hideModel");
  addedLearnerResults.value = false;

  // Clear the form after learner is added
  newLearner.value = {
    lastName: "",
    firstName: "",
    email: "",
    studentNumber: "",
    password: ""
  };
};

// Function to validate if an email already exists using the learner store
const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await learnerStore.validateEmail(node.value as string);
    return !emailExists;
  } catch (error) {
    return true;
  }
};

const mathsClasses = computed(() => {
  const currentGrade = filterStore.selectedFilters.gradeLevel;
  const classes = filterStore.selectedSchoolClasses
    .filter(
      (classGroup) =>
        classGroup.gradeLevel === currentGrade &&
        classGroup.subject === getSubjectIdFromName("Maths")
    )
    .map((classGroup) => ({
      value: classGroup._id,
      label: classGroup.name,
    }));
  return [{ value: "", label: "Select Class" }, ...classes];
});

const englishClasses = computed(() => {
  const currentGrade = filterStore.selectedFilters.gradeLevel;
  const classes = filterStore.selectedSchoolClasses
    .filter(
      (classGroup) =>
        classGroup.gradeLevel === currentGrade &&
        classGroup.subject === getSubjectIdFromName("English")
    )
    .map((classGroup) => ({
      value: classGroup._id,
      label: classGroup.name,
    }));
  return [{ value: "", label: "Select Class" }, ...classes];
});

const getSubjectName = computed(() => {
  const currentSubject = filterStore.selectedFilters.subject;
  const subjectName = filterStore.filterOptions?.subjects.find(
    (item: any) => item._id === currentSubject
  );
  return subjectName?.name;
});

const getSubjectIdFromName = (subjectName) => {
  const subject = filterStore.filterOptions?.subjects.find(
    (item: any) => item.name === subjectName
  );
  return subject?._id;
};

//set subject and class defaults
watch(
  () => props.classId,
  (newClassId) => {
    const currentSubject = getSubjectName.value;
    if (currentSubject === "Maths") {
      newLearner.value.subjects.maths = true;
      newLearner.value.mathsClass = newClassId;
    }
    if (currentSubject === "English") {
      newLearner.value.subjects.english = true;
      newLearner.value.englishClass = newClassId;
    }
  },
  { immediate: true }
);

//if the grade changes
watch(
  () => filterStore.selectedFilters.gradeLevel,
  (newGrade) => {
    newLearner.value.grade = newGrade;
  },
  { immediate: true }
);

//if the school changes
watch(
  () => filterStore.selectedFilters.school,
  (schoolId) => {
    newLearner.value.schoolId = schoolId;
  },
  { immediate: true }
);


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: updateSingleLearner.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all py-3 w-[27rem]" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("student_table_view.add_student")), 1)
                            ]),
                            _createVNode(_component_FormKit, {
                              type: "form",
                              modelValue: newLearner.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newLearner).value = $event)),
                              actions: false,
                              id: "new-learner-form",
                              onSubmit: onCreateLearner
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_FormKit, {
                                    type: "text",
                                    label: _ctx.$t('student_table_view.table.first_name'),
                                    id: "firstName",
                                    name: "firstName",
                                    "outer-class": "input-thin ",
                                    placeholder: 
                          _ctx.$t('student_table_view.table.first_name_example')
                        ,
                                    validation: "required",
                                    classes: {
                          outer: 'col-span-2',
                        }
                                  }, {
                                    suffix: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }, 8, ["label", "placeholder"]),
                                  _createVNode(_component_FormKit, {
                                    type: "text",
                                    label: _ctx.$t('student_table_view.table.last_name'),
                                    id: "lastName",
                                    name: "lastName",
                                    "outer-class": "input-thin",
                                    placeholder: 
                          _ctx.$t('student_table_view.table.last_name_example')
                        ,
                                    validation: "required",
                                    suffixIcon: false,
                                    classes: {
                          outer: 'col-span-2',
                        }
                                  }, {
                                    suffix: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  }, 8, ["label", "placeholder"]),
                                  _createVNode(_component_FormKit, {
                                    type: "text",
                                    name: "studentNumber",
                                    label: _ctx.$t('student_table_view.table.student_number'),
                                    "outer-class": "input-thin",
                                    placeholder: "1123",
                                    classes: {
                          outer: 'col-span-2',
                        }
                                  }, {
                                    suffix: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_FormKit, {
                                    type: "email",
                                    name: "email",
                                    id: "email",
                                    label: _ctx.$t('student_table_view.table.email'),
                                    "outer-class": "input-thin",
                                    placeholder: 
                          _ctx.$t('student_table_view.table.email_example', {
                            char: '@',
                          })
                        ,
                                    validation: "required|(500)email_exists",
                                    "validation-rules": { email_exists: email_exists },
                                    "validation-messages": {
                          email_exists: _ctx.$t(
                            'bulk_learner_upload_component.preview_learners.email_validation'
                          ),
                        },
                                    classes: {
                          outer: 'col-span-3',
                          input: 'mr-[5rem]',
                        }
                                  }, {
                                    suffix: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("h3", {
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (generateEmail())),
                                          class: "text-[#425467] font-semibold text-xs cursor-pointer absolute right-2"
                                        }, _toDisplayString(_ctx.$t("student_table_view.generate")), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["label", "placeholder", "validation-rules", "validation-messages"]),
                                  _createVNode(_component_FormKit, {
                                    type: passwordVisible.value ? 'text' : 'password',
                                    name: "password",
                                    label: _ctx.$t('student_table_view.table.password'),
                                    "outer-class": "input-thin",
                                    placeholder: 
                          _ctx.$t('student_table_view.table.password_example')
                        ,
                                    validation: "required",
                                    classes: {
                          outer: 'col-span-3',
                        }
                                  }, {
                                    suffix: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("img", {
                                          src: getPasswordIcon.value,
                                          alt: "First Suffix Icon",
                                          class: "suffix-icon cursor-pointer mr-[4.5rem]",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePasswordVisibility('password')))
                                        }, null, 8, _hoisted_14),
                                        _createElementVNode("h3", {
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (generatePassword())),
                                          class: "text-[#425467] font-semibold text-xs cursor-pointer absolute mt-1 right-2"
                                        }, _toDisplayString(_ctx.$t("student_table_view.generate")), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["type", "label", "placeholder"]),
                                  _hoisted_15,
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createVNode(_component_FormKit, {
                                        type: "checkbox",
                                        name: "maths",
                                        label: "Maths",
                                        "outer-class": "flex items-center gap-2 text-[#344054]",
                                        modelValue: newLearner.value.subjects.maths,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newLearner.value.subjects.maths) = $event)),
                                        config: {
                              classes: {
                                input: 'form-checkbox h-6 w-6 text-blue-600 bg-gray-100 border-gray-300 rounded-md focus:ring-blue-500 focus:ring-2',
                                label: 'text-md pl-2 leading-none',
                              },
                            }
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_FormKit, {
                                        type: "checkbox",
                                        name: "english",
                                        label: "English",
                                        "outer-class": "flex items-center gap-2 ml-2 text-[#344054]",
                                        modelValue: newLearner.value.subjects.english,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newLearner.value.subjects.english) = $event)),
                                        config: {
                              classes: {
                                input: 'form-checkbox h-6 w-6 text-blue-600 bg-gray-100 border-gray-300 rounded-md focus:ring-blue-500 focus:ring-2',
                                label: 'text-md pl-2 leading-none',
                              },
                            }
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      (newLearner.value.subjects.maths)
                                        ? (_openBlock(), _createBlock(_component_FormKit, {
                                            key: 0,
                                            type: "select",
                                            name: "mathsClass",
                                            label: "Maths Class",
                                            "label-class": "text-[#344054]",
                                            "outer-class": "w-full",
                                            modelValue: newLearner.value.mathsClass,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newLearner.value.mathsClass) = $event)),
                                            options: mathsClasses.value,
                                            validation: "required"
                                          }, null, 8, ["modelValue", "options"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                      (newLearner.value.subjects.english)
                                        ? (_openBlock(), _createBlock(_component_FormKit, {
                                            key: 0,
                                            type: "select",
                                            name: "englishClass",
                                            label: "English Class",
                                            "label-class": "text-[#344054]",
                                            "outer-class": "w-full",
                                            modelValue: newLearner.value.englishClass,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newLearner.value.englishClass) = $event)),
                                            options: englishClasses.value,
                                            validation: "required"
                                          }, null, 8, ["modelValue", "options"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: closeModal,
                                    class: "w-1/2 justify-center font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-center bg-white"
                                  }, _toDisplayString(_ctx.$t("student_table_view.btn_cancel")), 1),
                                  _createVNode(_component_FormKit, {
                                    type: "submit",
                                    "outer-class": 'w-1/2 bg-[#0060EE] text-white py-[0.11rem] rounded-lg flex items-center justify-center cursor-pointer'
                                  }, {
                                    default: _withCtx(() => [
                                      (_unref(learnerStore).loader.learner)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                            _createVNode(_component_spinner_loader, { color: 'text-white text' }),
                                            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(learnerStore).loadingMessage), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("student_table_view.btn_submit")), 1))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                (_unref(noSeats))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createVNode(_unref(XCircleIcon), {
                                            class: "h-5 w-5 text-red-400",
                                            "aria-hidden": "true"
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t(
                                "bulk_learner_upload_component.preview_learners.license_validation"
                              )), 1)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: addedLearnerResults.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 p-3 w-full max-w-[415px]" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("h1", _hoisted_37, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.title")), 1),
                            _createElementVNode("p", _hoisted_38, [
                              _createElementVNode("span", _hoisted_39, _toDisplayString(newLearner.value.firstName) + " " + _toDisplayString(newLearner.value.lastName), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.$t('student_table_view.confirm_modal.to')
                              }, null, 8, _hoisted_40),
                              _createElementVNode("span", _hoisted_41, _toDisplayString(__props.className), 1)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("button", {
                                class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-2 w-full focus:outline-none",
                                onClick: handleConfirmLearner
                              }, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.btn_edit")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})